import { render } from "./agregarProducto.vue?vue&type=template&id=3187b548&scoped=true"
import script from "./agregarProducto.vue?vue&type=script&lang=js"
export * from "./agregarProducto.vue?vue&type=script&lang=js"

import "./agregarProducto.vue?vue&type=style&index=0&id=3187b548&scoped=true&lang=css"
import "./agregarProducto.vue?vue&type=style&index=1&id=3187b548&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.41_vue@3.5.41_webpack@5.109.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3187b548"]])

export default __exports__